'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollToTop = require('./ScrollToTop');

Object.defineProperty(exports, 'ScrollToTop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollToTop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/scrollToTop/index.js
// module id = 599
// module chunks = 0